import * as v from "valibot";

import { rpcContract } from "../rpc";

export const brandsSearchRpcContract = rpcContract({
  name: "brandsSearch",
  paramsSchema: v.object({
    searchTerm: v.string(),
    selectedBrandIds: v.array(v.string()),
  }),
  resultSchema: v.array(
    v.object({
      id: v.string(),
      name: v.string(),
    }),
  ),
});

export type BrandsSearchParams = v.InferOutput<(typeof brandsSearchRpcContract)["paramsSchema"]>;
export type BrandsSearchResult = v.InferOutput<(typeof brandsSearchRpcContract)["resultSchema"]>;
